<template>
    <div style="width:100%;heigh:100%;">
        <el-row class="operateBtn-wrap">
			<el-button type="primary" icon="el-icon-arrow-left" size="small" @click="backToOrderView">返回</el-button>
		</el-row>
       
        <!--配置问题类型开始-->
        <el-row>
            <el-col :span="12">
                <div class="" @keydown.enter="search">
                <span class="title" style="width:60px">问题类型：</span>
                    <el-input size="small" style="max-width:180px" v-model="errSearch.value"  maxlength="16" placeholder="问题类型"></el-input>
                </div>
            </el-col>
            <el-col :span="12">
                <div style="text-align:right">
                    <el-button size="mini" icon="el-icon-search" type="primary" @click="search">查询</el-button>
                    <el-button size="mini" icon="el-icon-refresh" @click='clearSearch1'>重置</el-button>
                </div>
            </el-col>
        </el-row>
        <el-row v-if="permission.btn_repairProblem_add">
            <el-col>
                    <el-button icon="el-icon-plus" type="primary" size="small" @click="addErrItem()">新增</el-button>
            </el-col>
        </el-row>
        <el-table :data="errList" stripe style="width: 100%" class="deviceTable">
            <el-table-column prop="value" label="问题类型" min-width="160"></el-table-column>
            <el-table-column prop="gmtCreate" label="创建时间" :formatter='parseStartTime' ></el-table-column>
            <el-table-column prop="gmtModified" label="修改时间" :formatter='parseModifiedDate' ></el-table-column>
            <el-table-column label="操作" fixed="right" width="140">
                <template slot-scope="scope">
                    <el-button type="text" @click="showEditErrDialog(scope.row)" v-if="permission.btn_repairProblem_update" size="small">编辑</el-button>
                    <el-button type="text" @click="deleteErrItem(scope.row)" v-if="permission.btn_repairProblem_delete" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="page" v-if="errList.length > 0">
            <div class="total_page"><span> 共{{tableTotalPage1}}条 10条/页</span></div>
            <div style="margin-top:10px;text-align:right; margin-bottom:20px;" >
                <el-pagination background layout="prev, pager, next" :total="tableTotalPage1" @current-change="pageChange1" :current-page="tableCurrentPage1">
                </el-pagination>
            </div>
        </div>
            
        <el-dialog title="新增问题类型" @close="cancelErrDialog" :visible.sync="addErrDialogVisible"  :width="span==5?'45%':'28%'" center :close-on-click-modal="false">
            <el-form :model="configForm" :rules="rules" ref="configForm" style="width:100%;" class="add_form">
                <el-row>
                    <el-col :span="20" :offset="2">
                        <div class="" >
                            <span class="title">问题类型：</span>
                            <el-form-item prop="value"  :rules="rules.value" style="display: inline-block;">
                                <el-input ref="focusinput" size="small" style="max-width:180px" v-model="configForm.value"  maxlength="16" placeholder="问题类型"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addErrType">确 定</el-button>
                <el-button @click="cancelErrDialog" >取 消</el-button>
            </span>
        </el-dialog>

        <el-dialog title="编辑问题类型" @close="cancelEditErrDialog" :visible.sync="editErrDialogVisible"  :width="span==5?'45%':'28%'" center :close-on-click-modal="false">
            <el-form :model="configForm" :rules="rules" ref="configForm" style="width:100%;" class="add_form">
                <el-row>
                    <el-col :span="20" :offset="2">
                        <div class="" >
                            <span class="title">问题类型：</span>
                            <el-form-item prop="value"  :rules="rules.value" style="display: inline-block;">
                                <el-input size="small" style="max-width:180px" v-model="configForm.value"  maxlength="16" placeholder="问题类型"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="editErrType">确 定</el-button>
                <el-button @click="cancelEditErrDialog" >取 消</el-button>
            </span>
        </el-dialog>
       
    </div>
</template>

<script>
const log =console.log.bind(console)
import commom from '../../util/CommonUtils'
export default {
    name: 'ErrConf',
    
	data () {
        return {
            tableCurrentPage1:1,
            errList:[],
            editErrDialogVisible:false,
            addErrDialogVisible:false,
            tableTotalPage1:0,
            configForm:{
                value:''
            },
            errSearch:{
                value:''
            },
            rules:{
               
                value:[
                    { required: true, message: '请输入问题类型', trigger: 'blur' }
                ],
            },
            W:false,
            permission:JSON.parse(localStorage.getItem("permission")) 
        }
    },
    mounted:function(){
        this.loadErrList()
        let w  = document.documentElement.clientWidth || document.body.clientWidth;
        w>=1900?this.W = true:this.W = false
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
        }
    },
    computed:{
        span(){
           return 1.1
        }
    },
    deactivated:function(){
        console.log("deactivated");
    },
    methods:{
        deleteErrItem(rowData){
            this.$confirm('此操作将删除该问题类型, 删除后不可撤销，是否继续?', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$RequestUtil.post({
                    url: '/api/repairProblemDefine/deleteRepairProblem',
                    type:'sync',
                    params: {
                        id:rowData.id
                    },
                    success: (res) => {
                        if(res.code != -1){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.loadErrList()
                        }else{
                            this.$message.error(res.msg||res.message)
                        }
                    }
                })
            })
        },
        cancelEditErrDialog(){
            this.editErrDialogVisible = false
            this.configForm.value = ''
        },
        showEditErrDialog(rowData){
            this.editErrDialogVisible = true
            this.configForm.value = rowData.value
            this.configForm.id = rowData.id
        },
        editErrType(){
            this.$refs['configForm'].validate((valid) => {
                if(valid){
                    this.$RequestUtil.post({
                        url: '/api/repairProblemDefine/updateRepairProblem',
                        type:'sync',
                        params: this.configForm,
                        success:(res)=>{
                            if(res.code==0){
                                this.loadErrList()
                                this.$message.success('编辑成功')
                                this.cancelEditErrDialog()
                            }else{
                                this.$message.error(res.msg||res.message)
                            }
                            
                        },
                    })
                }
            })
        },
        cancelErrDialog(){
            this.addErrDialogVisible = false
            this.configForm.value = ''
        },
        pageChange1:function(targetPage){
            this.tableCurrentPage1 = targetPage;
            this.loadErrList()
        },
        addErrItem(){
            this.addErrDialogVisible = true
            setTimeout(()=>{
                this.$refs.focusinput.focus()
            },0)
        },
        addErrType(){
            this.$refs['configForm'].validate((valid) => {
                if(valid){
                    this.$RequestUtil.post({
                        url: '/api/repairProblemDefine/addRepairProblem',
                        type:'sync',
                        params: this.configForm,
                        success:(res)=>{
                            if(res.code==0){
                                this.loadErrList()
                                this.$message.success('添加成功')
                                this.cancelErrDialog()
                            }else{
                                this.$message.error(res.msg||res.message)
                            }
                            
                        },
                    })
                }
            })
        },
        search(){
            this.loadErrList(1)
        },
        loadErrList(type){
            this.$RequestUtil.get({
                url: '/api/repairProblemDefine/listRepairProblem',
                type:'sync',
				params: {
                    pageNum:type?type:this.tableCurrentPage1,
                    pageSize:10,
                    value:this.errSearch.value
                },
                success: (res) => {
                    if(res.msg == this.$Global.RESPONSE.SUCCESS){
                        this.errList = res.data;
                        this.tableTotalPage1 = res.totalPages;
                        if(res.totalPages == 0){
                            this.$message.warning('查询不到符合条件的数据');
                        }
                        
                        eventBus.$emit("error-change");
                    }else{
                        this.$message.error(res.msg||res.message)
                    }
                }
            })
        },
        backToOrderView(){
            this.$parent.showPage = 0;
            // let page = this.selectedOrder.oldPage
            // this.$parent.reload(page)
        },
         clearSearch1(){
            let form = this.errSearch;
            form.value='';
        },
        parseStartTime:function(rowData){
            if(rowData.gmtCreate != null){
                let dateString = commonUtils.timestampToDate(rowData.gmtCreate);
                return dateString
            }
        },
        parseEndTime:function(rowData){
            if(rowData.deadline != null){
                let dateString = commonUtils.timestampToDate(rowData.deadline,true);
                return dateString.substring(0,dateString.length-3);
            }
        },
         parseModifiedDate(rowData){
            if(rowData.gmtModified != null){
                let dateString = commonUtils.timestampToDate(rowData.gmtModified);
                return dateString;
            }
        },
    }
}
</script>

<style scoped>
.pic_warp{
    width: 86px;
    height: 86px;
    border: 2px #ccc dashed;
    cursor: pointer;
    border-radius: 2px;
}
.wrong_img{
    width: 80px;
    height: 80px;
    background-size: cover;
    margin: 3px;
    border-radius: 2px;
}
.table_searchbar .title11{
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
    display:inline-block;
    width: 70px;
    text-align: right
}
.title {
  display: inline-block;
  width: 90px;
text-align: right;
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  color: #606266;
}
.value {
  display: inline-block;
  width: 200px;
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  color: #606266;
}
.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
}

.table_searchbar{
    width:100%;
    margin-top: 10px;
    margin-bottom: 20px;
}
.import_upload{
	display: inline;
}
.page{
    display: flex;
    justify-content: flex-end;
}

.total_page{
    margin-top: 20px;
    margin-right: 26px;
    color:#606266;
    font-size: 14px;
}
</style>
<style>
.table_searchbar .el-button--mini, .el-button--mini.is-round {
    padding: 7px 10px;
}
</style>




// WEBPACK FOOTER //
// src/views/devicecare/ErrConf.vue